
import Spinwheel from '../Spinwheel';

function JobApplicationModal({ formik, modalId, loader }) {
// console.log('fmfmfm',formik)
  return (
    <>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog  modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                id="confirmModalCloseBtn"
                type="button"
                className="btn-close block-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pe-0 ps-0">
              <div className="container">
                <h2><span className="text-capitalize">{formik?.values?.type}</span> Job Application</h2>
                <form onSubmit={formik?.handleSubmit} >

                  <div className='row '>
                   
                    <div className="mb-3">
                      <label htmlFor="status" className="form-label">Status</label>
                      <select className="form-select w-100" name='status'   value={formik?.values?.status} aria-label="" onChange={formik?.handleChange} >
                    <option value="submitted">submitted</option>
                    <option value="application viewed">application viewed</option> 
                    <option value="shortlisted">shortlisted</option>
                    <option value="rejected">rejected</option>
                  </select>
                      {formik.touched.status && formik.errors.status ? (
                        <div className='req-error'>{formik.errors.status}</div>
                      ) : null}
                    </div>

                  </div>
                  <button type="submit" disabled={loader} onClick={formik.handleSubmit} className="btn btn-primary">
                    {loader ? <Spinwheel sizeClass={"spin-small"} /> : "Submit"}
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default JobApplicationModal